import React, { useContext } from "react";
import { AppContext } from "../../context";

function NoResults(props) {
  const info = useContext(AppContext);

  const style = {
    width: "100%",
    backgroundColor: "white",
    color: "black",
    textAlign: "center",
    padding: 10,
    fontSize: 20,
  };

  return <div style={style}>{info.t("noResults")}</div>;
}

export default NoResults;
